import { z } from "zod";

//DiarioObrasEfetivoSchema

const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);

export const DiarioObrasEfetivoSchema = z.object({
  IdDiarioObras: optionalNumber,
  IdDiarioObrasEfetivo: optionalNumber,
  IdCargo: z.number().int({ message: "O cargo é obrigatório" }),
  // TIPO (0 = Própria, 1 = Terceirizada)
  Tipo: optionalNumber,
  Categoria: z.number().nullable().optional(),
  Quantidade: optionalNumber,
  Descricao: optionalString,
  // ID_FORNECEDOR (Usado apenas se for terceirizada - Nullable)
  IdFornecedor: optionalNumber,
  
  //Extra
  IdsFuncionarios: z.number().array().nullable().optional(),

});

// DiarioObrasEfetivoForm
export type DiarioObrasEfetivoForm = z.infer<typeof DiarioObrasEfetivoSchema>;